export default __webpack_public_path__ + "static/media/30-min.c80149da.jpg";